import { loginAPI } from '../adapters/admin-dashboard-adapter';
import { LOGIN_CONST } from "../common/constant/page-constants";
import { setCookieCustom } from '../common/utils/StorageUItils';

export const login = (data) => {

    let reqData = {
        email: data.email,
        password: data.password
    }

    let promise = new Promise(function (resolve, reject) {

        loginAPI(reqData).then((res) => {

            if (res && res.data && res.data.data) {
                const { accessToken, refreshToken } = res.data.data;

                if (accessToken) {
                    setCookieCustom(LOGIN_CONST.ACCESS_TOKEN, accessToken);
                }

                if (refreshToken) {
                    setCookieCustom(LOGIN_CONST.REFRESH_TOKEN, refreshToken);
                }

                if (!accessToken) {
                    reject(new Error('Login Failure'));
                    return;
                }

                resolve(res.data.data);
            } else {
                reject(new Error('Login Failure'));
            }
        }).catch((err) => {
            reject(err);
        })
    });

    return promise;
}
